var map = {
	"./Application.jpg": 2087,
	"./Game.jpg": 2088,
	"./Music.jpg": 2089,
	"./Video.jpg": 2090,
	"./Wallpaper.jpg": 2091,
	"./Yummy Recipe.jpg": 2092,
	"./Yummy-Recipe.jpg": 2093
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2086;


//////////////////
// WEBPACK FOOTER
// ./src/assets/prizeo/imgs/browse ^\.\/.*\.jpg$
// module id = 2086
// module chunks = 0